import { render } from "./TablePage.vue?vue&type=template&id=80fb0948"
import script from "./TablePage.vue?vue&type=script&lang=js"
export * from "./TablePage.vue?vue&type=script&lang=js"

import "./TablePage.vue?vue&type=style&index=0&id=80fb0948&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__